/* Javascript - Swipers (carousels) */

/* Initialize swiper - Hero */
var heroSwiper = new Swiper("#hero-swiper", {
  effect: "fade",
  autoplay: {
    delay: 10000, // 10 seconds
    disableOnInteraction: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".hero-swiper-pagination",
    clickable: true,
  },
});

/* Initialize swiper - Activities */
var activitiesSwiper = new Swiper("#activities-swiper", {
  autoHeight: false,
  effect: "fade",
  autoplay: {
    delay: 10000, // 10 seconds
    disableOnInteraction: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".activities-swiper-pagination",
    clickable: true,
  },
});

/* Initialize swiper - Latest posts */
var latestPostsSwiper = new Swiper("#latest-posts-swiper", {
  autoHeight: true,
  slidesPerView: 1,
  spaceBetween: 20,
  loop: false,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    960: {
      slidesPerView: 2,
    },
    1400: {
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: ".custom-swiper-button-next",
    prevEl: ".custom-swiper-button-prev",
  },
});

/* Initialize swiper - Team */
var teamSwiper = new Swiper("#team-swiper", {
  autoHeight: true,
  slidesPerView: 3,
  spaceBetween: 8,
  loop: false,
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".custom-swiper-button-next",
    prevEl: ".custom-swiper-button-prev",
  },
});

/* Initialize swiper - Partners */
var partnersSwiper = new Swiper("#partners-swiper", {
  freeMode: true,
  slidesPerView: "auto",
  slidesPerGroup: 4,
  grid: {
    rows: 2,
  },
  slideClass: "kg-card",
  navigation: {
    nextEl: ".custom-swiper-button-next",
    prevEl: ".custom-swiper-button-prev",
  },
});
